//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as parkingLotApi from '@/api/parkingLotApi';
import ParkingLotDialog from './components/ParkingLotDialog.vue';
export default {
  name: 'ParkingLotList',
  components: {
    ParkingLotDialog: ParkingLotDialog
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        parkName: '',
        parkCode: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      parkingLotApi.getParkingLotList(this.listPram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        parkName: '',
        parkCode: ''
      };
      this.handlerGetListData();
    },
    handleAdd: function handleAdd() {
      this.$refs.parkingLotDialogRef.open({});
    },
    handleEdit: function handleEdit(row) {
      var _this2 = this;
      parkingLotApi.getParkingLotDetail(row.id).then(function (res) {
        _this2.$refs.parkingLotDialogRef.open(res);
      }).catch(function () {
        _this2.$message.error('获取停车场详情失败');
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('确定要删除该停车场吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        parkingLotApi.deleteParkingLot(row.id).then(function () {
          _this3.$message.success('删除成功');
          _this3.handlerGetListData();
        }).catch(function () {
          _this3.$message.error('删除失败');
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    }
  }
};